import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

let constModalRootElement: any;

interface ModalComponentArgs {
  fadeIn?: boolean; // default true
  large?: boolean; // large modal, default false
  onCloseRequested?: () => void;
}

export default class ModalComponent extends Component<ModalComponentArgs> {
  @tracked applyShowClass = false;

  get fadeIn() {
    return this.args.fadeIn ?? true;
  }

  get modalRootElement() {
    if (constModalRootElement) {
      return constModalRootElement;
    }
    return (constModalRootElement = document.getElementById('modal-root'));
  }

  closeRequested() {
    this.args.onCloseRequested?.();
  }

  handleClick = (e: any) => {
    if (e.target === e.currentTarget) {
      this.closeRequested();
    }
  };

  handleDocumentKeydown = (e: any) => {
    // escape key
    if (e.key === 'Escape') {
      this.closeRequested();
    }
  };

  templateDidInsert = () => {
    document.body.classList.add('modal-open');
    document.addEventListener('keydown', this.handleDocumentKeydown);
    if (this.fadeIn) {
      setTimeout(() => {
        this.applyShowClass = true;
      });
    } else {
      this.applyShowClass = true;
    }
  };

  templateWillDestroy = () => {
    document.body.classList.remove('modal-open');
    document.removeEventListener('keydown', this.handleDocumentKeydown);
  };
}
